import React from 'react';
import { Route } from 'react-router-dom';

import LocationsGrid from './LocationsGrid';
import LocationsForm from './LocationsForm';

/**
 * Contenedor de Locations. La RUTA decide qué se monta (no un flag isDetail):
 *  - /Locations              → lista (LocationsGrid)
 *  - /Locations/:locationId  → formulario (LocationsForm); 'undefined' = nuevo
 * El `key` fuerza re-montar el form al cambiar de id (p.ej. tras crear uno nuevo).
 */
export default function Locations(props) {
  const nivel = props.nivel;

  return (
    <>
      <Route exact path="/Locations"
        render={() => <LocationsGrid nivel={nivel} />} />

      <Route path="/Locations/:locationId"
        render={({ match }) => (
          <LocationsForm
            key={match.params.locationId}
            nivel={nivel}
            locationId={match.params.locationId}
          />
        )} />
    </>
  );
}
